import { useServerEnrolledStatsigExperiment } from '../../../../../../context/experiments';
import {
    AdsSearchUpsellExperiment,
    AdsSearchUpsellExperimentValues,
} from '../../../../../../types';

export function useSearchAdsUpsellExperiment() {
    const { variant } =
        useServerEnrolledStatsigExperiment<AdsSearchUpsellExperimentValues>({
            name: AdsSearchUpsellExperiment.name,
            paramName: AdsSearchUpsellExperiment.paramName,
            defaultValue: AdsSearchUpsellExperiment.values.control,
        });

    return variant === AdsSearchUpsellExperiment.values.withUpsell;
}
